var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      { staticClass: "activity-button", attrs: { "data-bot": _vm.dataBot } },
      _vm.$listeners
    ),
    [
      _c("CompassObject", {
        attrs: { object: _vm.object, size: "extra-small" }
      }),
      _vm._v(" "),
      _c("button", { staticClass: "typographies-paragraph-medium-semibold" }, [
        _vm._v(_vm._s(_vm.label))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }